// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_jy-0";
export var fulfillmentPanelBody = "_jy-1";